import { render, staticRenderFns } from "./Orderlist.vue?vue&type=template&id=045e968e&"
import script from "./Orderlist.vue?vue&type=script&lang=js&"
export * from "./Orderlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports